import dynamic from 'next/dynamic';

export const TACReconfirmationModalDynamic = dynamic(
  () =>
    import('./TACReconfirmationModal.client').then((mod) => ({
      default: mod.TACReconfirmationModal,
    })),
  { ssr: false },
);
